import React, { FC, useEffect } from 'react'
import { usePlaidLink } from 'react-plaid-link'

import { usePlaid } from './plaid/PlaidContext'
import Button, { ButtonVariants } from './Button'
import { MessageTypes, TaskStatus } from '@mortgage-pos/types'
import { useStoreActions, useStoreState } from '../store'

interface PlaidLinkProps {
  content?: string
  btnClassName?: string
  modifierClass?: string
  variant?: ButtonVariants
}

export const PlaidLink: FC<PlaidLinkProps> = ({
  variant = ButtonVariants.next,
  content = 'Connect Your Bank Account',
  btnClassName,
  modifierClass,
}) => {
  const { setPlaidModalOpen, plaidModalOpen } = usePlaid()

  const linkToken = useStoreState((state) => state.plaid.linkToken)
  const isLoading = useStoreState((state) => state.plaid.isLoading)
  const isMiniFlow = useStoreState((state) => state.questionnaire.isMiniFlow)

  const initializePlaid = useStoreActions(
    (actions) => actions.plaid.initializePlaid
  )
  const getConnectedAccounts = useStoreActions(
    (actions) => actions.plaid.getConnectedAccounts
  )
  const updatePlaidTaskStatus = useStoreActions(
    (actions) => actions.task.updatePlaidTaskStatus
  )

  const { open, ready } = usePlaidLink({
    token: linkToken,
    onSuccess: () => {
      getConnectedAccounts()
      setPlaidModalOpen(false)
    },
    onExit: (err) => {
      console.log('onExit', err)
      setPlaidModalOpen(false)
    },
    onEvent: (eventName: string, metadata: any) => {
      if (
        eventName === 'OPEN' ||
        (eventName === 'TRANSITION_VIEW' && metadata.view_name === 'CONSENT')
      ) {
        setPlaidModalOpen(true)
      }
    },
  })

  useEffect(() => {
    if (plaidModalOpen && ready && !isLoading) {
      if (isMiniFlow) {
        window.parent.postMessage(
          {
            name: MessageTypes.MiniFlowTaskStarted,
          },
          '*'
        )
      } else {
        updatePlaidTaskStatus({
          status: TaskStatus.InProgress,
        })
      }

      open()
    }
  }, [isLoading, linkToken, plaidModalOpen])

  const onClickHandler = async () => {
    await initializePlaid()
    setPlaidModalOpen(true)
  }

  return (
    <div
      className={`plaid-link ${modifierClass || ''}`}
      data-testid="plaid-link"
    >
      <Button
        variant={variant}
        className={btnClassName || ''}
        content={isLoading ? 'Connecting...' : content}
        onClick={onClickHandler}
        disabled={isLoading}
      />
    </div>
  )
}

export default PlaidLink
